import React, { Component } from 'react';

export default class Button extends Component {
  render() {
    return (
      this.props.type === 'submit' ? (

        <button className={"btn " + this.props.classNames}
                type={this.props.type}
                disabled={this.props.disabled}
                onClick={this.props.onClick} >

          {
            this.props.icon && this.props.iconPosition === 'left' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }

          {this.props.inner}

          {
            this.props.icon && this.props.iconPosition === 'right' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }
        </button>

      ) : this.props.href ? (
        <a href={this.props.href}
           className={"btn " + this.props.classNames}
           target={this.props.target}
           rel={this.props.rel} >

          {
            this.props.icon && this.props.iconPosition === 'left' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }

          {this.props.inner}

          {
            this.props.icon && this.props.iconPosition === 'right' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }

        </a>
      ) : (
        <div className={"btn " + this.props.classNames} onClick={this.props.onClick} >

          {
            this.props.icon && this.props.iconPosition === 'left' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }

          {this.props.inner}

          {
            this.props.icon && this.props.iconPosition === 'right' ? (
              <i className={"icon icon-" + this.props.icon}>
              </i>
            ) : (
              null
            )
          }

        </div>
      )
    )
  }
}
